import type { TableState } from '@restaurant/api-client';

// One source of truth for how a table's live state looks across the floor
// (drawn plan), the grid and the list. Tints are deliberately soft so an
// occupied room reads at a glance without becoming a colour soup. Text labels
// live in i18n (tableGrid.*) - this lib only owns colour, keyed by
// `STATE_LABEL_KEY` so callers translate without hardcoding English here.
export const STATE_STYLE: Record<
  TableState['state'],
  { dot: string; tint: string; stroke: string }
> = {
  AVAILABLE: {
    dot: '#34c759',
    tint: 'rgba(52,199,89,0.10)',
    stroke: 'rgba(52,199,89,0.55)',
  },
  RESERVED: {
    dot: '#ff9500',
    tint: 'rgba(255,149,0,0.12)',
    stroke: 'rgba(255,149,0,0.6)',
  },
  OCCUPIED: {
    dot: 'var(--f7-theme-color)',
    tint: 'var(--f7-theme-color-tint)',
    stroke: 'var(--f7-theme-color)',
  },
};

/** Maps a table's live state to its `tableGrid.*` i18n key. */
export const STATE_LABEL_KEY: Record<TableState['state'], 'free' | 'reserved' | 'openTab'> = {
  AVAILABLE: 'free',
  RESERVED: 'reserved',
  OCCUPIED: 'openTab',
};

/** Compact "open for" duration from an ISO instant. */
export function relTime(iso: string | null): string {
  if (!iso) return '';
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  return `${h}h ${mins % 60}m`;
}
